import React,{useState,}from 'react'
import { Modal} from 'antd';
import ArapDesc from './ArapDesc';
function ArapCheck(props) {   
    const [open,setOpen] = useState(false);
    return (
        <>
            <a onClick={() => {setOpen(true)}}>已下账</a>
            <Modal                 
                open={open} 
                onOk={() => {setOpen(true)}} 
                onCancel={() => {setOpen(false)}} 
                okText='关闭' 
                width={1280}
                footer={null}
            >
               <ArapDesc 
                    eie_hx_number = {props.eie_hx_number}
                    open={open}
               />    
            </Modal>
        </>
    )
}

export default ArapCheck